export const convertToISOFrom = (inputDate) => {
  const dateObj = new Date(inputDate);
  dateObj.setHours(0, 0, 0, 0);
  return dateObj.toISOString();
};

export const convertToISOTo = (inputDate) => {
  const dateObj = new Date(inputDate);
  dateObj.setHours(23, 59, 59, 999);
  return dateObj.toISOString();
};

export const setCookie = (name, value, duration, unit = "days") => {
  let expires = "";
  if (duration) {
    const date = new Date();
    if (unit === "days") {
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000);
    } else if (unit === "minutes") {
      date.setTime(date.getTime() + duration * 60 * 1000);
    }
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = (
  name,
  expires = "Thu, 01 Jan 1970 00:00:00 UTC"
) => {
  document.cookie = `${name}=; expires=${expires}; path=/;`;
};

export const userRegistrationGTM = (companyId) => {
  let dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "registration_complete",
    company_id: companyId,
    utm_source: getCookie("utm_source"),
    utm_medium: getCookie("utm_medium"),
    utm_campaign: getCookie("utm_campaign"),
    utm_term: getCookie("utm_term"),
    utm_content: getCookie("utm_content"),
    registration_date: new Date().toISOString(),
  });
  console.log("dataLayer", dataLayer);
};
